var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestPlanningActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,23.7c0.1,0.1,0.3,0.2,0.4,0.2C1.2,23.8,1.1,23.8,0.9,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,21h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-0.3-0.3-0.6-0.6-0.6h-1.9c-0.3,0-0.6,0.3-0.6,0.6v1.9 C16.5,20.7,16.8,21,17.1,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,21h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-0.2-0.1-0.4-0.4-0.5l-2.6,2.5C4.6,20.8,4.8,21,5.1,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.1,15h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-0.3-0.3-0.6-0.6-0.6h-1.9c-0.3,0-0.6,0.3-0.6,0.6v1.9 C16.5,14.7,16.8,15,17.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,18h-1.9c-0.3,0-0.6,0.3-0.6,0.6v1.9c0,0.3,0.3,0.6,0.6,0.6h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9 C13.5,18.3,13.2,18,12.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.1,15h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-0.1-0.1-0.2-0.1-0.3l-2.7,2.6C10.7,14.9,10.9,15,11.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,18H5.1c-0.3,0-0.6,0.3-0.6,0.6v1.9c0,0,0,0,0,0.1L7.1,18C7.1,18,7,18,6.9,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,12h-1.9c-0.3,0-0.6,0.3-0.6,0.6v1.9c0,0.1,0.1,0.2,0.1,0.3l2.7-2.6C13.3,12.1,13.1,12,12.9,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,15h1.9c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-0.3-0.3-0.6-0.6-0.6H5.1c-0.3,0-0.6,0.3-0.6,0.6v1.9 C4.5,14.7,4.8,15,5.1,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,7.5h4.1V5.3c0-0.5-0.1-0.9-0.4-1.2L18.4,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.2,3H18V0.8C18,0.3,17.7,0,17.2,0h-1.5C15.3,0,15,0.3,15,0.8V3H9V0.8C9,0.3,8.7,0,8.2,0H6.8 C6.3,0,6,0.3,6,0.8V3H3.8C2.5,3,1.5,4,1.5,5.3v2.3h16.9L22.1,4C21.7,3.4,21,3,20.2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,12.6v1.9c0,0.3-0.3,0.6-0.6,0.6h-1.9c-0.2,0-0.3-0.1-0.4-0.2L7.1,18c0.2,0.1,0.4,0.3,0.4,0.5v1.9 c0,0.3-0.3,0.6-0.6,0.6H5.1c-0.3,0-0.5-0.2-0.5-0.5L1.9,23c0.4,0.6,1.1,1,1.9,1h16.5c1.2,0,2.3-1,2.3-2.3V9h-5.7l-3.4,3.2 C13.4,12.3,13.5,12.4,13.5,12.6z M13.5,20.4c0,0.3-0.3,0.6-0.6,0.6h-1.9c-0.3,0-0.6-0.3-0.6-0.6v-1.9c0-0.3,0.3-0.6,0.6-0.6h1.9 c0.3,0,0.6,0.3,0.6,0.6V20.4z M16.5,12.6c0-0.3,0.3-0.6,0.6-0.6h1.9c0.3,0,0.6,0.3,0.6,0.6v1.9c0,0.3-0.3,0.6-0.6,0.6h-1.9 c-0.3,0-0.6-0.3-0.6-0.6V12.6z M16.5,18.6c0-0.3,0.3-0.6,0.6-0.6h1.9c0.3,0,0.6,0.3,0.6,0.6v1.9c0,0.3-0.3,0.6-0.6,0.6h-1.9 c-0.3,0-0.6-0.3-0.6-0.6V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.5,21.8c0,0.5,0.1,0.9,0.4,1.2l2.6-2.5c0,0,0,0,0-0.1v-1.9c0-0.3,0.3-0.6,0.6-0.6h1.9c0.1,0,0.1,0,0.2,0 l3.5-3.3c-0.1-0.1-0.1-0.2-0.1-0.3v-1.9c0-0.3,0.3-0.6,0.6-0.6h1.9c0.2,0,0.3,0.1,0.4,0.2L16.8,9H1.5V21.8z M4.5,12.6 c0-0.3,0.3-0.6,0.6-0.6h1.9c0.3,0,0.6,0.3,0.6,0.6v1.9c0,0.3-0.3,0.6-0.6,0.6H5.1c-0.3,0-0.6-0.3-0.6-0.6V12.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPlanningActive);
export default __webpack_public_path__ + "static/media/test-planning-active.5147c8cacecc64a5f272d7e2f137bf5f.svg";
export { ForwardRef as ReactComponent };